import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFloor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 23 22",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	},
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "Laag-1",
		"serif:id": "Laag 1"
	}), /* @__PURE__ */ _jsxs("g", {
		id: "Laag-11",
		"serif:id": "Laag 1",
		transform: "matrix(0.956305,0,0,0.906672,0.186389,0.324632)",
		children: [
			/* @__PURE__ */ _jsx("g", {
				transform: "matrix(1.066293,0,0,1.194374,1.905182,-2.990128)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M17.79,11.08L17.79,19.34C17.79,19.34 17.71,21.25 16.02,21.37C14.33,21.49 2.43,21.37 2.43,21.37C1.37,21.37 0.51,20.51 0.51,19.44L0.51,10.75C0.51,10.18 0.76,9.64 1.19,9.28L7.9,3.49C8.62,2.88 9.66,2.88 10.38,3.49L17.1,9.28C17.53,9.65 17.78,10.19 17.78,10.75",
					style: {
						fill: "none",
						fillRule: "nonzero",
						stroke: "currentColor",
						strokeWidth: "1.51px"
					}
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "matrix(1.066293,0,0,1.194374,1.905182,-2.990128)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M3.29,11.08L15.2,11.08",
					style: {
						fill: "none",
						fillRule: "nonzero",
						stroke: "currentColor",
						strokeWidth: "1.51px"
					}
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				transform: "matrix(1.066293,0,0,1.194374,1.905182,-2.990128)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M15.2,16.54L3.29,16.52",
					style: {
						fill: "none",
						fillRule: "nonzero",
						stroke: "currentColor",
						strokeWidth: "1.51px"
					}
				})
			})
		]
	})]
});
export default SvgFloor;
